// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__ZLYNB","active":"Tab_active__gfuYe"};